export default __webpack_public_path__ + "static/media/xl_uni.9c9e061b.png";